import { render } from "./BreadCrumbComponent.vue?vue&type=template&id=97046394&scoped=true"
import script from "./BreadCrumbComponent.vue?vue&type=script&lang=js"
export * from "./BreadCrumbComponent.vue?vue&type=script&lang=js"

import "./BreadCrumbComponent.vue?vue&type=style&index=0&id=97046394&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-97046394"]])

export default __exports__